import { render, staticRenderFns } from "./MInplayMulti.vue?vue&type=template&id=0f5f986e&scoped=true"
import script from "./MInplayMulti.vue?vue&type=script&lang=js"
export * from "./MInplayMulti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5f986e",
  null
  
)

export default component.exports